import React, {useEffect, useRef, useState} from 'react';
import {IonRow, IonCol, IonButton, IonModal, useIonModal, IonIcon} from '@ionic/react';
import './MopFooter.scss';
import { ApplicationState } from '../store';
import * as BasketStore from '../store/BasketStore';
import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import * as currencyHelpers from '../helpers/currencyHelpers';

import { useHistory } from 'react-router';
import { simpleChannelType } from '../store/LocationStore';
import Button from './Button';
import {documentTextOutline, timeOutline} from "ionicons/icons";
import {useWaitTimes} from "../helpers/waitTimesHelper";
import { WaitTimesButton, WaitTimesModal } from "./wait-times/WaitTimesModal";

const MopFooterList: React.FC = () => {
    const [showModal, setShowModal] = useState(false);
    const locationState = useSelector((state: ApplicationState) => state.location);
    const headerFooterStore = useSelector((state: ApplicationState) => state.headerFooter);
    const boundCalculateBasket = bindActionCreators(BasketStore.actionCreators.calculateBasket, useDispatch());
    const basketStore = useSelector((state: ApplicationState) => state.basket);

    let price: string = currencyHelpers.formatCurrency(basketStore?.basket.totalPrice);
    let basketEnabled = true;

    const history = useHistory();

    const { displayWaitTimes } = useWaitTimes();
    const [showWaitingModal, setShowWaitingModal] = useState<boolean>(false);

    if (!basketStore?.basket.totalPrice) {
        price = String.fromCharCode(163) + `0.00`;
        basketEnabled = false;
    }

    const goToBasket = () => {
        boundCalculateBasket(undefined);
        history.push(`/basketpage`);
    }

    useEffect(() => {
        if (headerFooterStore?.showBasketModal !== undefined) {
            setShowModal(headerFooterStore.showBasketModal);
        }
    }, [headerFooterStore?.showBasketModal]);
    
    return (
        <div className="MopFooterInner">
            <IonRow className="ion-align-items-center">
                <IonCol size="4">
                    <div className="FooterStoreWrapper" onClick={() => history.push("/storesearch")}>
                        <span
                            className="CollectFrom">{locationState?.selectedChannel === undefined ? "Store" : locationState.selectedChannel.channelType === simpleChannelType.ClickAndCollect ? "Take away" : "Eat in"}</span><br/>
                        <span
                            className="Location">{locationState?.selectedStore === undefined ? "Select a store" : locationState?.selectedStore.storeName}</span>
                        {locationState?.selectedStore?.takingMopOrders === false ?
                            <span style={{color: "#ff0"}}> - Order ahead not available</span> : null}
                    </div>
                    {displayWaitTimes && <WaitTimesButton onClick={() => setShowWaitingModal(true)} />}
                </IonCol>
                <IonCol size="8" className={`${!basketEnabled && "button-group-disabled"}`}>
                    <Button
                        onClick={goToBasket}
                        disabled={!basketEnabled}
                        expand="block"
                        color="light"
                        rounded
                    >
                        <span className="price">
                            {currencyHelpers.hasPrefixSymbol(price)
                                ?
                                <>
                                    <span className="sign">{price[0]}</span>
                                    {price.substring(1)}
                                </>
                                :
                                price
                            }
                        </span>
                    </Button>
                    <div className="nubbin">{basketStore?.totalQuantity}</div>
                </IonCol>
            </IonRow>
            <WaitTimesModal onDidDismiss={() => setShowWaitingModal(false)} showing={showWaitingModal} />
        </div>
    );
};

export default MopFooterList;
